import { useState } from 'react';

import { ButtonBase, ClickAwayListener, Stack, Tooltip } from '@mui/material';

import { LogoFlower } from '@/components/global/Logo';
import { isDev } from '@legacy/utils/env';
import styles from './DigitalAdoptionPlugin.module.scss';
import { TextLink, VisuallyHidden } from '../../ui-components';
import { Typography } from '../../mui-components';
import { Trans, useTranslation } from 'react-i18next';
import { useGetCurrentLanguage } from '@/legacy/apis/userSettingsAPI';

// Only Danish (da), Swedish (sv) or English (en) have help sites
const supportedHelpLanguages = ['da', 'sv', 'en'];

export const DigitalAdoptionPlugin = () => {
  // Call all hooks unconditionally before any early returns
  const { t } = useTranslation('digitalAdoption');
  const [open, setOpen] = useState(false);
  const { currentLanguage } = useGetCurrentLanguage();

  // Early return after all hooks have been called
  if (isDev) {
    return null;
  }

  const helpLanguage =
    currentLanguage && supportedHelpLanguages.includes(currentLanguage)
      ? currentLanguage
      : 'en';

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <Tooltip
          onClose={handleClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <Stack gap={1} sx={{ p: 1 }}>
              <Typography component="h2" sx={{ fontSize: '18px' }}>
                {t('Heading')}
              </Typography>
              <Typography sx={{ fontSize: '14px' }}>
                <Trans
                  i18nKey="Text"
                  ns="digitalAdoption"
                  key="Text"
                  defaults={t('Text')}
                  components={[
                    <TextLink
                      href={`https://help.timelog.com/${helpLanguage}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      inline
                    />,
                  ]}
                />
              </Typography>
              <Typography sx={{ fontSize: '14px' }}>
                <Trans
                  i18nKey="Text2"
                  ns="digitalAdoption"
                  key="Text2"
                  defaults={t('Text2')}
                  components={[
                    <TextLink
                      href="https://17i92.share.hsforms.com/2YchjxvuQSW2yiKWRL4irrw"
                      target="_blank"
                      rel="noopener noreferrer"
                      inline
                    />,
                  ]}
                />
              </Typography>
            </Stack>
          }
          slotProps={{
            popper: {
              disablePortal: true,
            },
          }}
        >
          <ButtonBase
            type="button"
            onClick={handleClickOpen}
            className={styles.Button}
          >
            <VisuallyHidden>{t('ButtonText')}</VisuallyHidden>
            <LogoFlower color="#fff" />
          </ButtonBase>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};
